import { formatDate } from "../utilities/date";
import { displayMoney } from "../utilities/displayValues";

export const columnsApagar = [
    {
        field: 'destinatario_conta',
        headerName: 'DESTINATARIO',
        width: 380,
    },
    {
        field: 'categoria_conta',
        headerName: 'CATEGORIA',
        width: 200,
    },
    {
        field: 'data_vencimento',
        headerName: 'VENCIMENTO',
        valueFormatter: (dt: any) => formatDate(dt),
        width: 200,
    },
    {
        field: 'valor_pagar',
        headerName: 'VALOR',
        width: 200,
        valueFormatter: (val: string | number) => displayMoney(val),
    },
    {
        field: 'status_conta',
        headerName: 'STATUS',
        width: 200,
    },
];